module.exports = __webpack_public_path__ + "media/components/Sponsors/Projects/Show/dummy-fa47fec96849c868d6a2ad4786058d1f.png";